import i18n from "@/i18n";
import moment from "moment";
import VConsole from "vconsole";

const url = new URL(location.href);
const searchParams = url.searchParams;

const language =
  searchParams.get("language") ||
  localStorage.getItem("language") ||
  navigator.language ||
  navigator.userLanguage ||
  "cn";

if (
  (searchParams.get("console") || localStorage.getItem("console")) === "Bd2vk6"
) {
  localStorage.setItem("console", "Bd2vk6");
  new VConsole();
} else {
  console.log = function () {};
}

const state = {
  name: "Angry Miao",
  language: "cn",
  isCN: true,
  isTest:
    location.href.includes("test.angrymiao.com") ||
    !location.href.includes(".angrymiao.com"),
};

const actions = {
  setLanguage({ commit }, language) {
    console.log(language);
    let lang = language.toLowerCase();
    switch (lang) {
      case "cn":
      case "zh-cn":
      case "zh_cn":
      case "zh-tw":
      case "zh_tw":
        lang = "cn";
        moment.locale("zh-CN");
        i18n.locale = lang;
        document.documentElement.setAttribute("lang", "zh-CN");
        localStorage.setItem("language", lang);
        break;
      case "ja":
      case "ja-jp":
      case "ja_jp":
        lang = "ja";
        moment.locale("ja-JP");
        i18n.locale = lang;
        document.documentElement.setAttribute("lang", "ja-JP");
        localStorage.setItem("language", lang);
        break;
      default:
        lang = "en";
        moment.locale(lang);
        document.documentElement.setAttribute("lang", lang);
        localStorage.setItem("language", lang);
        break;
    }
    i18n.locale = lang;
    console.log(lang);
    if (commit) {
      commit("SET_LANGUAGE", lang);
    } else {
      state.language = language;
      state.isCN = language === "cn";
    }
  },
};

actions.setLanguage({}, language);

const mutations = {
  SET_LANGUAGE: (state, language) => {
    state.language = language;
    state.isCN = language === "cn";
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
